module.exports = __webpack_public_path__ + "static/media/pdp.105571b3.png";